export default "__VITE_ASSET__DufRcyX7__"